import React from 'react'
import Header from '../../../Pages/Header/Header'
import Clients from '../../Admin/Clients/Clients'
import HeaderDash from '../../Admin/HeaderDash/HeaderDash'
export default function index() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <Clients />
                </div>
            </section>
        </div>
    )
}
